import * as React from "react";
import { Box, Link, Typography } from "@mui/material";
import { ImagesContext } from "../Context";
import moment from "moment";

const DatePartial: React.FC = () => {
  const images = React.useContext(ImagesContext);
  const currentDate = moment().format("MM/DD/YYYY");

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box
        className="date-box"
        sx={{
          width: "90%",
          height: 41.13,
          backgroundColor: "#efe9e7",
          display: "flex",
          alignItems: "center",
          paddingLeft: "11px",
        }}
      >
        <Typography sx={{ color: "gray" }}>{currentDate}</Typography>
      </Box>
      <Link className="invite-app-user-link" style={{ cursor: "none" }}>
        <img
          src={images.calendar_icon}
          alt="Calendar"
          className="action-icon-image"
          style={{ width: 22.75, maxHeight: 26 }}
        />
      </Link>
    </Box>
  );
};

export default DatePartial;
